import CreateAccount from 'features/signup/CreateAccount/CreateAccount';
import React from 'react';

export default function CreateAccountScreen() {
  return <CreateAccount />;
}
